import axiosInstance from '../utils/axios';

const BASE = '/admin/passes-insurance';

export async function listDriverPasses(params = {}) {
  const { data } = await axiosInstance.get(`${BASE}/driver-passes`, { params });
  return data;
}

export async function setDriverPass(riderId, body) {
  const { data } = await axiosInstance.put(`${BASE}/driver-passes/${riderId}`, body);
  return data;
}

export async function removeDriverPass(riderId) {
  const { data } = await axiosInstance.delete(`${BASE}/driver-passes/${riderId}`);
  return data;
}

export async function listFleetInsurance(params = {}) {
  const { data } = await axiosInstance.get(`${BASE}/fleet-insurance`, { params });
  return data;
}

export async function setFleetInsurance(divisionTruckId, body) {
  const { data } = await axiosInstance.put(`${BASE}/fleet-insurance/${divisionTruckId}`, body);
  return data;
}

export async function bulkSetDivisionInsurance(body) {
  const { data } = await axiosInstance.post(`${BASE}/fleet-insurance/bulk`, body);
  return data;
}

export async function removeFleetInsurance(divisionTruckId) {
  const { data } = await axiosInstance.delete(`${BASE}/fleet-insurance/${divisionTruckId}`);
  return data;
}

export async function listDivisionTrucks(divisionId) {
  const id = String(divisionId || '').trim();
  if (!id || id === 'undefined' || !/^[a-f0-9]{24}$/i.test(id)) {
    return [];
  }
  const { data } = await axiosInstance.get(`${BASE}/divisions/${id}/trucks`);
  return data.items || [];
}
